import { connect } from 'react-redux';
import { get } from 'lodash';
import dictionariesTypesEnum from '../../../../common/constants/dictionaries';
import CountryTableSelect from './component';
import { initCountries } from './actions';

const mapStateToProps = (state) => ({
  countries: get(state, `dictionaries.${dictionariesTypesEnum.country}.dictionary`, []),
});

const mapDispatchToProps = (dispatch) => ({
  initCounrtyList: () => dispatch(initCountries()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CountryTableSelect);
